<template>
    <div class="pp-cell-group">
        <div v-if="title" class="pp-cell-group__title"
            :class="'is-' + titlePosition">
            {{title}}
        </div>
        <slot></slot>
    </div>
</template>

<script>
/**
 * 单元组
 * @desc 只能包含<pp-cell>
 * @param {boolean} withMore 子组件cell带右侧箭头，true时会覆盖cell的withIcon
 * @param {string} title 标题
 * @param {string} titlePosition 标题对其方式,默认left
 */
export default {
    name: 'pp-cell-group',
    provide: function() {
        return {
            'CellGroup': this,
        };
    },
    props: {
        withMore: Boolean,
        title: String,
        titlePosition: {
            type: String,
            default: 'left',
        },
    },
}
</script>
